import { FC, createContext, useState } from "react";
import ApiService from "../_services/ApiService";
import { error } from "console";

interface Props {
  children: React.ReactNode;
}

export interface SearchType {
  startDate: string;
  endDate: string;
  studentStageIds: string | null;
}

interface GetFollowupFormConfigsResponse {
  followupFormConfigs: object | null;
  error: any;
}

interface SearchFollowupsResponse {
  redirectToId: string | null;
  error: any | null;
}

interface GetFollowupFromIdResponse {
  followup: object | null;
  error: any;
}

interface FollowupContextType {
  searchFollowups: (search: SearchType) => Promise<SearchFollowupsResponse>;
  getFollowupFormConfigs: () => Promise<GetFollowupFormConfigsResponse>;
  getFollowupFromId: (followupId: string) => Promise<GetFollowupFromIdResponse>;
  getNextPageDetails: (
    currentPageFollowupId: string
  ) => Promise<SearchFollowupsResponse>;
  getStudentStage: (id: string) => string;
  getPrevPageDetails: (
    currentPageFollowupId: string
  ) => SearchFollowupsResponse;
  isPreviousDissabled: (currentPageFollowupId: string) => boolean;
  currentPageText: (currentPageFollowupId: string) => string;
}

export const FollowupContext = createContext<FollowupContextType>({
  searchFollowups: async () => ({} as SearchFollowupsResponse),
  getFollowupFormConfigs: async () => ({} as GetFollowupFormConfigsResponse),
  getFollowupFromId: async () => ({} as GetFollowupFromIdResponse),
  getNextPageDetails: async () => ({} as SearchFollowupsResponse),
  getStudentStage: () => "",
  getPrevPageDetails: () => ({} as SearchFollowupsResponse),
  isPreviousDissabled: () => true,
  currentPageText: () => "",
});

const convertDateFormat = (data: string) => {
  if (!data) return "";
  let date = new Date(data);
  let newdate =
    date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
  return newdate;
};

export const FollowupProvider: FC<Props> = ({ children }) => {
  const [followupFormConfigs, setFollowupFormConfigs] = useState(null);
  const [followupsData, setfollowupsData] = useState([]);
  const [savedSearch, setSavedSearch] = useState<SearchType>({} as SearchType);

  const [currentPage, setCurrentPage] = useState<number>(0);

  const searchFollowups = async (search: SearchType) => {
    console.log(search);
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    const startDate = convertDateFormat(search.startDate);
    const endDate = convertDateFormat(search.endDate);

    const searchDetails = {
      ...search,
      startDate,
      endDate,
      userId: currentUser.userId,
      page: 1,
    };

    try {
      const response = await ApiService.getFollowupDetails(searchDetails);
      console.log(response);
      const followups = response.data.followups;

      setSavedSearch(search);
      setCurrentPage(1);

      if (followups.length) {
        setfollowupsData(followups);
        const redirectToId = followups[0].followupId;
        console.log(redirectToId);
        return {
          redirectToId,
          error: null,
        };
      }

      return {
        redirectToId: null,
        error: "No Followups found",
      };
    } catch (error) {
      return {
        redirectToId: null,
        error,
      };
    }
  };

  const getFollowupFormConfigs = async () => {
    if (followupFormConfigs) return { followupFormConfigs, error: null };
    try {
      const response = await ApiService.getEnquiryFormControls();
      const configs = response.data;
      setFollowupFormConfigs(configs);
      return { followupFormConfigs: configs, error: null };
    } catch (error) {
      return { followupFormConfigs: null, error };
    }
  };

  const fetchFolloupsFromId = async (followupId: string) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    const searchDetails = {
      startDate: "",
      endDate: "",
      userId: currentUser.userId,
      followUpIds: followupId,
      page: 1
    };

    try {
      const response = await ApiService.getFollowupDetails(searchDetails);
      console.log(response);
      const followups = response.data.followups;

      if (followups.length) {
        setfollowupsData(followups);

        const followup = followups.find(
          (followupData) => followupData.followupId.toString() === followupId
        );


        if(followup){
          return followup;
        }

        return null;

      }

      return null;
    } catch (error) {
      console.log(error);

      return null;
    }
  };

  const getFollowupFromId = async (followupId: string) => {
    if (!followupsData.length) {
      const followup = await fetchFolloupsFromId(followupId);
      if(followup === null){
        return { error: "No data found", followup: null };
      }
      console.log(followup);
      return {
        followup,
        error: null,
      };

    }
    console.log("here");

    const followup = followupsData.find(
      (followupData) => followupData.followupId.toString() === followupId
    );

    if (!followup) {
      return { error: "No data found", followup: null };
    }

    return {
      followup,
      error: null,
    };
  };

  const requestNextPage = async (): Promise<SearchFollowupsResponse> => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));

    const startDate = convertDateFormat(savedSearch.startDate);
    const endDate = convertDateFormat(savedSearch.endDate);
    console.log(currentPage);
    console.log(savedSearch);

    const searchDetails = {
      ...savedSearch,
      startDate,
      endDate,
      userId: currentUser.userId,
      page: currentPage + 1,
    };

    try {
      const response = await ApiService.getFollowupDetails(searchDetails);
      console.log(response);
      const followups = response.data.followups;

      setCurrentPage(currentPage + 1);

      if (followups.length) {
        setfollowupsData([...followupsData, ...followups]);
        const redirectToId = followups[0].followupId;
        console.log(redirectToId);
        return {
          redirectToId,
          error: null,
        };
      }

      return {
        redirectToId: null,
        error: "no more followups",
      };
    } catch (error) {
      return {
        redirectToId: null,
        error,
      };
    }
  };

  const getNextPageDetails = async (currentPageFollowupId) => {
    let currentPageIndex = null;

    for (let i = 0; i < followupsData.length; i++) {
      if (followupsData[i].followupId.toString() === currentPageFollowupId) {
        currentPageIndex = i;
        break;
      }
    }

    console.log(followupsData, currentPageIndex);

    if (currentPageIndex + 1 === followupsData.length) {
      return await requestNextPage();
    }

    let redirectToId: string = followupsData[currentPageIndex + 1].followupId;

    return {
      redirectToId,
      error: null,
    };
  };

  const getPrevPageDetails = (currentPageFollowupId: string) => {
    let currentPageIndex = null;

    for (let i = 0; i < followupsData.length; i++) {
      if (followupsData[i].followupId.toString() === currentPageFollowupId) {
        currentPageIndex = i;
        break;
      }
    }

    let redirectToId: string = followupsData[currentPageIndex - 1].followupId;

    return {
      redirectToId,
      error: null,
    };
  };

  const isPreviousDissabled = (currentPageFollowupId: string) => {
    return followupsData[0]?.followupId.toString() === currentPageFollowupId;
  };

  const getStudentStage = (id: string) => {
    if (id === null || id === undefined) {
      return "";
    }

    if (!followupFormConfigs?.studentStages?.length) return "";

    const studentStage = followupFormConfigs.studentStages?.find(
      (studentStage) => studentStage.id === Number(id)
    );

    return studentStage?.name || "";
  };

  const currentPageText = (currentPageFollowupId: string) => {
    if (!currentPageFollowupId) return "";
    if (!followupsData.length) return "";

    let currentPageIndex = null;

    for (let i = 0; i < followupsData.length; i++) {
      if (followupsData[i].followupId.toString() === currentPageFollowupId) {
        currentPageIndex = i;
        break;
      }
    }

    console.log("here");
    if (currentPageIndex === null) return "";

    return `showing ${currentPageIndex + 1} of ${followupsData.length}`;
  };

  const value = {
    searchFollowups,
    getFollowupFormConfigs,
    getFollowupFromId,
    getNextPageDetails,
    getStudentStage,
    getPrevPageDetails,
    isPreviousDissabled,
    currentPageText,
  };

  return (
    <FollowupContext.Provider value={value}>
      {children}
    </FollowupContext.Provider>
  );
};
